<template>
	<div class="container tac">
		<div class="m_sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="headline_m">
						{{ $t('rtr_business-how-pay.title1') }}
					</p>
					<p class="body_m">
						{{ $t('rtr_business-how-pay.text1') }}<br />
						{{ $t('rtr_business-how-pay.text2') }}
					</p>
					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button
							class="button_bg_black"
							@click="$router.push({ name: 'cs' })"
						>
							{{ $t('button.info') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="m_sub_middle body_l">
				<p>{{ $t('rtr_business-how-pay.text3') }}</p>
				<button class="button_bg_red" @click="$router.push({ name: 'cs' })">
					{{ $t('rtr_business-how-pay.text4') }}
				</button>
			</div>
			<div class="content_area">
				<div class="m_sub_bottom">
					<h2 class="headline_m">
						{{ $t('rtr_business-how-pay.title2') }}
					</h2>
					<p class="body_m">
						{{ $t('rtr_business-how-pay.text5') }}<br />
						{{ $t('rtr_business-how-pay.text6') }}
					</p>
				</div>
			</div>
		</section>

		<section class="content_area">
			<div class="detail_area">
				<div class="detail">
					<h2 class="headline_s">
						{{ $t('rtr_business-how-pay.title3') }}
					</h2>
					<div class="img_area_02">
						<img src="@/assets/images/sub/business_pay_02.png" alt="" />
					</div>
					<div class="text">
						<p class="body_m">
							{{ $t('rtr_business-how-pay.text7') }}
						</p>
						<router-link
							:to="{ name: '' }"
							class="m_link_type_02"
							@click="notYet"
						>
							{{ $t('rtr_business-how-pay.text8') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
			</div>
			<div class="detail_area">
				<div class="detail">
					<h2 class="headline_s">
						{{ $t('rtr_business-how-pay.title4') }}
					</h2>
					<div class="img_area_02"></div>
					<img src="@/assets/images/sub/business_pay_03.png" alt="" />
					<div class="text">
						<p class="body_m">
							{{ $t('rtr_business-how-pay.text9') }}
						</p>
						<router-link
							:to="{ name: '' }"
							class="m_link_type_02"
							@click="notYet"
						>
							{{ $t('rtr_business-how-pay.text10') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
			</div>
			<div class="detail_area">
				<div class="detail tac">
					<h2 class="headline_s">
						{{ $t('rtr_business-how-pay.title5') }}
					</h2>
					<div class="img_area_02">
						<img src="@/assets/images/sub/business_pay_04.png" alt="" />
					</div>
					<div class="text">
						<p class="body_m">
							{{ $t('rtr_business-how-pay.text11') }}
						</p>
						<router-link :to="{ name: 'auth-register' }" class="m_link_type_02">
							{{ $t('rtr_business-how-pay.text12') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
			</div>
		</section>

		<section class="pt_10">
			<div class="sub_content">
				<div class="text_area body_m">
					<p class="mb_20">{{ $t('rtr_business-how-pay.text13') }}</p>
					<p class="mb_20">
						{{ $t('rtr_business-how-pay.text14') }}
					</p>
					<p>
						{{ $t('rtr_business-how-pay.text15') }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
export default {
	name: 'Pay.m',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>

<style scoped></style>
